import React from 'react'
import './ScrollableTable.scss'
import { useTranslation } from 'react-i18next'

export interface Column {
  key: string
  label: string
  width?: number // opcional
  translationKeyPrefix?: string // opcional, para traducciones
}

interface ScrollableTableProps {
  columns: Column[]
  data: Record<string, any>[]
  maxHeight?: number
}

const ScrollableTable: React.FC<ScrollableTableProps> = ({
  columns,
  data,
  maxHeight = 500,
}) => {
  const { t }: any = useTranslation()

  return (
    <div className="table-wrapper" style={{ maxHeight }}>
      <div className="table-scroll">
        <table className="custom-table">
          <thead>
            <tr>
              {columns.map((col) => (
                <th key={col.key} style={{ width: col.width }}>
                  {col.label}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {data.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {columns.map((col) => (
                  <td key={col.key}>
                    <div className="cell-content">
                      {col.translationKeyPrefix && row[col.key]
                        ? t(`${col.translationKeyPrefix}.${row[col.key]}`)
                        : row[col.key]}
                    </div>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default ScrollableTable
